import { FormControlLabel, TextField } from '@mui/material'
import { styled } from '@mui/material/styles'

export const InputWrapper = styled('div')({
  width: 'auto',
  marginTop: '5px',
})

export const TextInput = styled(TextField)({
  '&.MuiTextField-root': {
    '.MuiInputBase-root': {
      '.MuiInput-input': {
        '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
          '-webkit-appearance': 'none',
          margin: 0,
        },
      },
    },
  },
})

export const Label = styled('label')(({ theme }) => ({
  color: theme.palette.grey[500], //theme.GREY
  fontSize: '13px',
}))

export const CheckBox = styled(FormControlLabel)(({ theme }) => ({
  '.MuiSwitch-root': {
    '.MuiSwitch-switchBase': {
      '&:hover': {
        backgroundColor: theme.palette.primary.light, //'#23619230'
      },
      '&.Mui-checked': {
        color: theme.palette.primary.main, //theme.PRIMARY
        '&:hover': {
          backgroundColor: theme.palette.primary.light, //'#9ebcff33'
        },
      },
      '&.Mui-checked+.MuiSwitch-track': {
        backgroundColor: theme.palette.primary.main, //theme.PRIMARY
      },
      '&.Mui-checked+.MuiSwitch-switchBase': {
        backgroundColor: theme.palette.primary.main, //theme.PRIMARY
      },
    },
  },
  '.MuiTypography-root': {
    color: 'black',
    fontSize: '14px',
  },
}))
